import { Link, useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";

export default function NotFound() {
  const location = useLocation();

  return (
    <Layout title="页面不存在">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center px-4 py-24 text-center md:px-6">
        <h1 className="font-heading text-9xl font-black text-background-200 select-none md:text-[12rem]">
          404
        </h1>
        <div className="relative z-10 -mt-10">
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">这个页面不存在</h2>
          <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
          <p className="mt-4 text-base text-foreground-600">返回首页继续浏览漫画软件应用内容吧</p>
          <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
            <Link to="/" className="inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-lg bg-primary-500 px-6 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600">
              返回首页
            </Link>
            <Link to="/rankings" className="inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-lg border-2 border-primary-500 px-6 py-2.5 text-sm font-bold text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50">
              查看排行榜
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}